import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useLocation } from '@grandvisionhq/frk-routing';
import { useFeatureToggles } from '@grandvisionhq/state';
import { defaultComponentDefinitions } from '../component-definitions.js';
import { createConfiguration } from '../configuration/configuration.js';
import { initialValue, BloomreachContext } from './context.js';

/**
 * This is in a separate module from BloomreachContext itself to avoid a
 * circular dependency between ../component-definitions and ../containers.
 * Do not re-export this from ./index
 */ function BloomreachProvider({ settings , children  }) {
    const { apiUrl , customComponentMap , componentDefinitions =defaultComponentDefinitions , excludeSkuFromProductUrls , pageModel , visitor ,  } = settings;
    const { isMultilingualEnabled  } = useFeatureToggles();
    const { pathname  } = useLocation();
    const sdkConfig = React.useMemo(()=>{
        return createConfiguration({
            apiUrl,
            path: pathname,
            options: {
                isMultilingual: isMultilingualEnabled,
                locale: settings.locale,
                visitor
            }
        });
    }, [
        apiUrl,
        isMultilingualEnabled,
        settings.locale,
        visitor,
        pathname
    ]);
    const value = React.useMemo(()=>swcHelpers.objectSpread({}, initialValue, {
            apiUrl,
            componentDefinitions,
            customComponentMap,
            excludeSkuFromProductUrls,
            pageModel,
            sdkConfig,
            isMultilingualEnabled
        })
    , [
        apiUrl,
        componentDefinitions,
        customComponentMap,
        excludeSkuFromProductUrls,
        pageModel,
        sdkConfig,
        isMultilingualEnabled, 
    ]);
    return /*#__PURE__*/ React.createElement(BloomreachContext.Provider, {
        value: value,
        children: children
    });
}

export { BloomreachProvider };
//# sourceMappingURL=Provider.js.map
